import ImaginaryModule from '~/lib/vue/modules/imaginary';

export default (services, namespace='imaginary') => {
  return ImaginaryModule.create({
    services,
  });
};
